import * as React from 'react';
import type { SVGProps } from 'react';
const SvgBoatRampPrivate = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={44} height={44} fill="none" {...props}>
    <circle cx={22} cy={22} r={22} fill="#F97316" />
    <g fill="#fff" clipPath="url(#boat_ramp_private_svg__a)">
      <path d="M36.193 20.26a1.18 1.18 0 0 0-.735-.66l-17.346-5.373 2.528-1.97a1.181 1.181 0 1 0-1.453-1.864l-3.826 2.982-5.122-1.586a1.178 1.178 0 0 0-1.477.779 8.215 8.215 0 0 0 .583 6.305 8.222 8.222 0 0 0 4.872 4.045l17.388 5.385a1.18 1.18 0 0 0 1.411-.61l3.154-6.448c.152-.31.16-.67.023-.987zm-4.855 5.488-16.422-5.085a5.873 5.873 0 0 1-3.48-2.89 5.867 5.867 0 0 1-.655-3.343l22.66 7.018zM34.542 31.546 9.244 23.71a1.18 1.18 0 0 0-1.531 1.128v4.418a1.181 1.181 0 1 0 2.363 0v-2.815l23.767 7.36a1.182 1.182 0 0 0 .7-2.257" />
    </g>
    <defs>
      <clipPath id="boat_ramp_private_svg__a">
        <path fill="#fff" d="M7.334 7.334h29.333v29.333H7.334z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgBoatRampPrivate;
